import script from "./importStudent.vue?vue&type=script&setup=true&lang=js"
export * from "./importStudent.vue?vue&type=script&setup=true&lang=js"

import "./importStudent.vue?vue&type=style&index=0&id=8f14c814&lang=scss"

const __exports__ = script;

export default __exports__